import {ref, reactive} from "vue";
import {defineStore} from "pinia";

export const useCharacteristicsStore = defineStore('characteristics', () => {
   const characteristics = reactive({});

   const updateCharacteristics = (chars: any) => {
       Object.keys(chars).forEach((key: any) => {
           // @ts-ignore
           characteristics[key] = chars[key];
       })
   };

   const getCharacteristics = () => characteristics;

   return {
       characteristics,
       updateCharacteristics,
       getCharacteristics,
   }
});